import helpers from "../../utils/helpers";
import { createDigitalId, getConsultSoat, getConsultSoatPrint } from "../../services/clientServices";

import {
    LOAD_CONSULT_SOAT,
    SUCCESS_CONSULT_SOAT,
    SUCCESS_CONSULT_SOAT_PRINT,
} from "../types/consultType";

import url from "../../utils/url";

import {
    ERROR_API,
    SUCCESS_STEP_ONE,
    SUCCESS_STEP_TWO,
} from "../../consts/const";

import {
    MARKING_EVENT_TRACK_ERROR,
} from "../../consts/markingsConst";

import { setErrorApi } from "../actions/errorApiAction";
import { getDataSoatOneStep } from "./oneStepAction";

const structDataConsult = (response, data) => {

    if (!response) return;

    if (response && data) {

        const { payload } = response;

        let plateFormat = helpers.agregarCaracter(data.placa, "-", 3)
        const statusSOAT = payload?.estado || '';

        let result = {
            startDate: payload?.fechaIinicioVigencia || '',
            endDate: payload?.fechaFinVigencia || '',
            emissionDate: payload?.fechaEmimsion || '',
            urlConstElect: payload?.url || '',
            numDoc: data?.numeroDocumento || '',
            plateFormat: plateFormat || '',
            plate: data?.placa || '',
            typeDoc: data?.tipoDocumento || '',
            company: payload?.compania || '',
            statusSOAT,
        }

        return result;
    }

}

export const getDataConsultSoat = (data, onestep) => async (dispatch) => {
    dispatch({
        type: LOAD_CONSULT_SOAT,
    });

    try {
        if (onestep) {
          getDataSoatOneStep({
            numDoc: data?.numeroDocumento || '',
            plate: data?.placa || '',
            typeDoc: data?.tipoDocumento || '',
          }, dispatch);
          await helpers.sleep(2000);
        }

        let step = '';
        const response = await getConsultSoat(data);
        const newData = structDataConsult(response, data);

        if (onestep) {
          await helpers.sleep(1000);
        }

        if (response) {
            dispatch({
                type: SUCCESS_CONSULT_SOAT,
                data: newData,
            });
            
            if (response?.payload?.fechaFinVigencia) step =  SUCCESS_STEP_ONE
            if ( response?.error?.code === '0000') {
                step = SUCCESS_STEP_TWO;
            }

            if (response?.error?.httpStatus === 500) {
                dispatch(setErrorApi(response.error, url.PATH_CONSULT_SOAT));
                helpers.getTagError( 'CodGenerico', 'Mensaje de error genérico', MARKING_EVENT_TRACK_ERROR);
                step = ERROR_API;
            }
        }
        return step;

    } catch (error) {
        dispatch(setErrorApi(error, url.PATH_CONSULT_SOAT));
        helpers.getTagError('CodGenerico', 'Mensaje de error genérico', MARKING_EVENT_TRACK_ERROR);
        return ERROR_API;
    }
};

export const getDataConsultSoatPrint = (data) => async (dispatch) => {
    dispatch({
        type: LOAD_CONSULT_SOAT,
    });

    try {
        const response = await getConsultSoatPrint(data);

        if (response?.payload?.rutaConstancia) {

            const rutaElectronica = response.payload.rutaConstancia;
            console.log('rutaElectronica>>>', rutaElectronica);
            dispatch({
                type: SUCCESS_CONSULT_SOAT_PRINT,
                data: rutaElectronica && `https://www.rimac.com.pe/ConsultaSOAT/${rutaElectronica}`,
            });
            return true
        }

        if (response?.error) {
            helpers.getTagError(response?.error?.code || 'CodGenerico', response?.error?.message[0] || 'Mensaje de error genérico', MARKING_EVENT_TRACK_ERROR);
            return false
        }


    } catch (error) {
        dispatch(setErrorApi(error, url.PATH_PRINT_CONSULT_SOAT));
        helpers.getTagError('CodGenerico', 'Mensaje de error genérico', MARKING_EVENT_TRACK_ERROR);
        return false
    }
};

export const getDigitalId = (data) => async (dispatch) => {
    dispatch({
      type: SUCCESS_CONSULT_SOAT_PRINT,
    });
   const id =  await createDigitalId(data);
   return id;
};
  